import styled from 'styled-components';
import { Button } from 'component-library-and-tools';

import { colors } from 'lib/prisma-styles';

export default styled(Button)`
  && {
    background-color: ${colors.interactive.primaryAction};
    padding: 1rem 1.666666667rem;
    border-radius: 2rem;
    font-weight: 700;
  }
`;
